<div class="pda-gallery">
    <div class="pda-gallery-tabs">
        <ul class="pda-gallery-tabs-list">
            <li *ngFor="let item of config.items">
                <button class="pda-btn primary-red" (click)="selectItem(item)">
                    {{ item.name }}
                </button>
            </li>
        </ul>
    </div>
    <div class="pda-gallery-picture">
        <figure>
            <div class="pda-gallery-picture-img" [ngStyle]="{
                'background-image': 'url(' + currentImage + ')'
            }">
                <div class="pda-gallery-picture-img-layer" *ngIf="currentImage !== config.defaultImage">
                    <h2 class="pda-gallery-picture-img-layer-title">{{ title }}</h2>
                    <p class="pda-gallery-picture-img-layer-description text-justify">{{ description }}</p>
                </div>
            </div>
        </figure>
    </div>
</div>
